import type { SavedEmailTemplate } from "@redotech/redo-model/saved-email-template";
import {
  savedEmailTemplateSchema,
  SavedEmailTemplateSource,
} from "@redotech/redo-model/saved-email-template";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const paginateSavedEmailTemplates = {
  name: "paginateSavedEmailTemplates" as const,
  input: z.object({
    limit: z.number().positive().optional(),
    searchText: z.string().optional(),
    source: z
      .union([
        createEnum(SavedEmailTemplateSource),
        z.array(createEnum(SavedEmailTemplateSource)),
      ])
      .optional(),
    page: z.number().positive().optional(),
    pageSize: z.number().positive().optional(),
  }),
  output: z.object({
    data: z.array(savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>),
    totalCount: z.number().optional(),
  }),
};
